export default "__VITE_ASSET__gci8Kg5a__"